import { adminHttpClient } from '../../../commons/adminHttpClient'

export interface ReimbursementValues {
  planPeriodId: string
  companyUserId: string
  scheduleDate: string
  amount: number
}

const editPastReimbursement = (reimbursement: ReimbursementValues): Promise<any> => {
  return adminHttpClient.put('/AdminDashboard/EditPastReimbursement', reimbursement)
}

export default editPastReimbursement
